import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class DeleteAction extends React.Component {
  delete() {
    let detail = this.props.detail;
    
    let chk = confirm('このインフルエンサーをリストから除外してもよろしいですか？\n※ステータスや下書きなどの進捗の情報は保持されます。必要の場合は再度候補者に追加をお願いします。');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/project/influencer/status_update', { project_id: detail.project_id, insta_user_id: detail.insta_user_id, update: { column: 'delete' } },
      function(res){
        this.props.close_ev.bind(this)();
        this.props.base.event.updateData('workflow', res.body.workflow);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    
    // アクション
    return (
      <div>
        <li className="on" onClick={this.delete.bind(this)}>
          {this.props.button}
        </li>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DeleteAction;